module.exports = "/images/model_ee729c.png";